import { sagas as precisionPolicy } from './precisionPolicy';
import { sagas as mbrPolicy } from './mbrPolicy';
import { sagas as schedule } from './schedule';

export default [
  ...precisionPolicy,
  ...mbrPolicy,
  ...schedule,
];
